import type { FC } from 'react';

import { isNextAuthEnabled } from '@eneco/auth';
import { LoginButton } from '@eneco/components-next/auth';
import { useLinkComponent } from '@eneco/link';
import { NavLink } from '@eneco/sparky';
import { ProfileIcon } from '@eneco/sparky/icons';
import { MainMenuRightRendering } from '@sitecore/types/manual/NavigationBar';

import usePlaceholderComponentContent from './usePlaceholderComponentContent';


const LoginMenu: FC = function () {
  const Link = useLinkComponent();
  const content = usePlaceholderComponentContent<MainMenuRightRendering>('jss-main-navigation-right', 'LoginMenu');
  if (!content) return null;

  const { fields } = content;

  if (!isNextAuthEnabled) {
    return (
      <Link href={fields.selfServiceLink.value.href} linkType={fields.selfServiceLink.value.linktype}>
        <NavLink leftIcon={<ProfileIcon />}>{fields.selfServiceLink.value.text}</NavLink>
      </Link>
    );
  }

  return (
    <LoginButton
      leftIcon={<ProfileIcon />}
      label={fields.selfServiceLink.value.text}
      callbackUrl={fields.selfServiceLink.value.href}
      sendLocale={!!fields.sendLocaleToOkta?.value}
    />
  );
};

export default LoginMenu;
